<template>
    <div class="category-box">
        <Breadcrumb :crumb="crumb"></Breadcrumb>
        <div class="category">
            <div class="left">
                <div class="main-color" @click="getAllCategoryList">热门定制</div>
                <div class="label-box" v-if="labelList.length > 0">
                    <div class="label " :class="item.id == label_id ? 'active' :'' "
                         v-for="(item,index) in labelList" :key="index" @click="chooseLabel(item.id)">
                        {{ item.label_name}}
                    </div>
                    <div class="cf"></div>
                </div>
                <div>
                    <Collapse v-model="selected_category">
                        <Panel :name="item.category_name" v-for="(item,index) in category_list" :key="'p-' + index">
                            {{ item. category_name}}
                            <div slot="content">
                                <p class="cate" v-for="(cItem,cIndex) in item.children" :key="'c-' + cIndex"
                                   @click="filter_category(cItem.category_id)">
                                    {{ cItem. category_name}}</p>
                            </div>
                        </Panel>
                    </Collapse>
                </div>

            </div>
            <div class="right flex flex-wrap">
                <router-link class="item" v-for="(item,index) in product_list" :key="`t-${index}`"
                             :to="{ name: 'CategoryDetail', query: {id : item.id, mtm_type:'3', category_id: current_category_id}}">
                    <div class="img">
                        <img :src="item.main_image"/>
                    </div>
                    <div class="name"> {{item. category_name_cn}}</div>
                    <div class="price flex align-center" :class="item.vip_price?'justify-end':'justify-center'">
                        <span>￥{{ item.price }}</span>
                        <span class="vip-price" v-if="item.vip_price">会员价￥{{ item.vip_price }}</span>
                    </div>
                </router-link>
                <div class="item">
                    <div class="img">
                        <img src="../../assets/images/category/more.png"/>
                    </div>
                    <div class="name">更多款式</div>
                    <div class="price"> 敬请期待</div>
                </div>
            </div>

        </div>


    </div>

</template>

<script>
    import Breadcrumb from "@/components/Breadcrumb.vue";
    import {MCategory, MTemplate, MTemplateDetail, GetLabelList} from "../../api";

    export default {
        name: "GroupCategory",
        components: {
            Breadcrumb
        },
        data() {
            return {
                crumb: [{
                    title: "团体定制",
                    path: "group_category",
                },],
                selected_category: null,
                category_list: [],
                current_category_id: 0,
                product_list: [],
                labelList: [],
                label_id: 0
            };
        },
        computed: {},
        mounted() {
            this.$emit('showLogin', true)
            this.$emit('showBack', false)
            this.$emit('showNav', true)
            this.$emit('showFooter', true)
        },
        methods: {
            pick(value) {
                MTemplateDetail({id: value.id}).then((response) => {
                    let category = response.data;
                    this.$store.commit('mtm/pick', {category})
                }).then(() => {
                    this.$router.push({name: 'Design', query: {id: value.id}, params: {is_group: 1}})
                })
            },
            filter_category(category_id) {
                this.current_category_id = category_id
                this.getTemplateList(category_id)
            },
            async geCategoryList(category_id) {
                return await MCategory({category_id}).then((response) => {
                    this.category_list = response.data
                })
            },
            async getTemplateList(category_ids) {
                return await MTemplate({category_ids, mtm_type: 3, label_id: this.label_id}).then((response) => {
                    this.product_list = response.data
                })
            },
            getAllCategoryList() {
                this.current_category_id = 0
                this.label_id = 0
                this.geCategoryList(this.current_category_id)
                this.getTemplateList(this.current_category_id)
            }

        },
        created() {
            if (this.$route.query.category_id) {
                this.current_category_id = this.$route.query.category_id
                this.getTemplateList(this.current_category_id)
                this.geCategoryList(0)
            } else {
                this.getAllCategoryList()
            }
            GetLabelList().then((res) => {
                this.labelList = res.data
            })
        }
    };
</script>

<style scoped lang="scss">
    .category-box {
        width: 1170px;
        margin: 20px auto;

        .category {
            margin-top: 20px;
            width: 100%;
            display: flex;

            .left {
                width: 300px;

                .label-box {
                    margin-top: 30px;

                    .label {
                        float: left;
                        padding: 0 10px;
                        height: 31px;
                        line-height: 31px;
                        background: #FFFFFF;
                        border: 1px solid #0F114A;
                        border-radius: 3px;
                        margin-right: 10px;
                        margin-bottom: 5px;
                        text-align: center;
                        font-size: 15px;
                        font-weight: bold;
                        color: #333333;
                        cursor: pointer;

                        &.active {
                            background: #0F114A;
                            color: #EDD4AC;
                        }
                    }

                    .cf {
                        clear: both;
                    }
                }
            }

            .right {
                width: 870px;

                .item:nth-child(3n) {
                    margin-right: 0px;
                }

                .item {
                    width: 270px;
                    height: 434px;
                    background: #ffffff;
                    box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
                    opacity: 1;
                    border-radius: 2px;
                    text-align: center;
                    margin-bottom: 20px;
                    margin-right: 30px;
                    display: inline-block;
                    cursor: pointer;

                    .img {
                        width: 270px;
                    }

                    .name {
                        font-size: 15px;
                        height: 40px;
                        color: #303030;
                        margin-top: 20px;
                        padding: 0 10px;
                        text-align: left;
                    }

                    .price {
                        font-size: 16px;
                        font-weight: bold;
                        color: #303030;
                        margin-top: 10px;
                        padding: 0 20px;

                        .vip-price {
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }

    .main-color {
        font-size: 16px;
        font-weight: bold;
        line-height: 28px;
    }

    .cate {
        margin-top: 20px;
        font-size: 15px;
        cursor: pointer;
    }
</style>
